module.exports = {
  9: 9,
  12: 12,
  belowModals: 9999,
  max: 10000,
  overModals: 9999999,
  overPage: 99999999,
};
